// extracted by mini-css-extract-plugin
export default {"searchContainer":"GlobalSearchModal_searchContainer__v9zS2","itemsContainer":"GlobalSearchModal_itemsContainer__TV+2Y"};